const actionTypes = { SET_CONTENT_STORE: 'SET_CONTENT_STORE' };

module.exports = actionTypes;
